<template>
  <Activity :title="t('app.login.title')" vertical="top" class="login-activity">
    <b-form @submit.prevent="onSubmit">
      <h1 v-text="t('app.login.title')"></h1>
      <p class="text-muted" v-text="t('app.login.message')"></p>

      <b-form-group>
        <input-with-fa-icon type="text" :placeholder="t('app.login.username')" icon="user" v-model="username" :disabled="loading"/>
      </b-form-group>
      <b-form-group>
        <input-with-fa-icon type="password" :placeholder="t('app.login.password')" icon="lock" v-model="password" :disabled="loading"/>
      </b-form-group>
      <b-form-group>
        <b-button type="submit" variant="primary" :disabled="!isValid || loading">
          <font-awesome-icon icon="check" v-if="!loading"/>
          <font-awesome-icon icon="spinner" spin v-else/>
          {{ t('app.login.button') }}
        </b-button>
      </b-form-group>
    </b-form>
  </Activity>
</template>

<script>

import Activity from "@/app/components/Activity.vue";
import InputWithFaIcon from "@/app/components/form/InputWithFaIcon.vue";
import {computed, ref} from "@vue/composition-api";

export default {
  components: {InputWithFaIcon, Activity},

  setup() {
    // eslint-disable-next-line no-undef
    const cookies = useCookies()
    // eslint-disable-next-line no-undef
    const store = useStore()
    // eslint-disable-next-line no-undef
    const router = useRouter()
    // eslint-disable-next-line no-undef
    const { t } = useI18n()

    const loading = ref(false)

    const username = ref('')
    const password = ref('')

    const isValid = computed(() => {
      return username.value.length > 2 && password.value.length > 6
    })

    const onSubmit = () => {
      loading.value = true

      cookies.remove('auth');

      store.dispatch('AUTH_LOGIN', {
        email: username.value,
        password: password.value,
        callBack: () => {
          store.dispatch('APP_FETCH_DELIVERY_CONFIG_ALL')
          loading.value = false
          router.push({ name: 'MainActivity' })
          // if(this.returnUrl)
          //   window.location.href = this.returnUrl;
          // else
          //   this.$router.push('/dashboard')
        },
        errorCallBack: () => loading.value = false
      })
    }

    return {
      t,
      loading,
      username,
      password,
      isValid,
      onSubmit,
    }
  },
}
</script>

<style lang="scss">
.login-activity {
  form {
    margin-top: 50px;
  }

  h1 {
    font-size: 30px;
  }
}
</style>
